import { render } from "./FooterUzbrusselfoundation.vue?vue&type=template&id=6baba3c9&scoped=true"
import script from "./FooterUzbrusselfoundation.vue?vue&type=script&lang=js"
export * from "./FooterUzbrusselfoundation.vue?vue&type=script&lang=js"

import "./FooterUzbrusselfoundation.vue?vue&type=style&index=0&id=6baba3c9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6baba3c9"]])

export default __exports__